module.exports = __webpack_public_path__ + "static/img/07.41d1e17a.png";